import {Alert} from "@mantine/core";
import { Eye as IconEye } from "@phosphor-icons/react";
import {Row} from "../../../components/Flex/Flex";
import CGT from "../../../utils/CGT.ts";

export default function LastSighting ({sighting}) {
    const date = CGT.fromSeconds(sighting.date);

    return (
        <Row justify="center" className="mt-2">
            <Alert color="yellow" icon={<IconEye size={16}/>}>{`Target last spotted at ${sighting.location.system.name} (${sighting.location.system.galX}, ${sighting.location.system.galY}) on ${date.toCGT(true)} by ${sighting.spotter}`}</Alert>
        </Row>

    )
}
